import { ComponentStyleConfig, extendTheme } from '@chakra-ui/react'

const ButtonStyle: ComponentStyleConfig = {
  // style object for base or default style
  baseStyle: {
    pt: '0.5em',
    pb: '0.5em'
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {
    solid: {
      bg: 'brand.500',
      color: 'brand.100',
      p: '0.5em',
      _hover: {
        bg: 'brand.500',
      },
      _focus: {
        bg: 'brand.500',
      }
    },
    solidSecondary: {
      bg: 'brand.500',
      color: 'brand.700',
      borderRadius: '2px',
      p: '0.5em',
      _disabled: {
        bg: 'brand.200',
        color: 'brand.700',
        opacity: 0.5
      }
    },
    mainSolid: {
      bg: 'brand.500',
      color: 'brand.100',
      p: '0.5em',
      _hover: {
        bg: 'brand.500',
      },
      _focus: {
        bg: 'brand.500',
      }
    },
  },
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: '',
    variant: 'solid',
    colorScheme: 'brand',
  },
}

const LinkStyle: ComponentStyleConfig = {
  defaultProps: {
    variant: 'brand'
  },
  variants: {
    brand: {
      color: 'brand.500'
    },
    white: {
      color: 'brand.100'
    }
  }
}

const ProgressStyle: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'brand',
    borderRadius: '1em'
  },
}

const HeadingStyle: ComponentStyleConfig = {
  defaultProps: {
    letterSpacing: '-1px !important',
  },
}

export const theme = extendTheme({
  fonts: {
    heading: 'Libre Franklin", sans-serif',
    body: 'Libre Franklin", sans-serif'
  },
  colors: {
    brand: {
      100: '#0162AA',
      200: '#eff3f6',
      300: '#5b8db6',
      400: 'rgb(106 191 75 / 60%)',
      500: '#0162aa',
      600: '#E6E7E8',
      700: '#FFFFFF',
      800: '#D50000',
      850: '#d44048',
      900: "#161622",
      950: "#143b63",
    },
    brand2: {
      500: '#d44048',
    }
  },
  components: {
    Button: ButtonStyle,
    Link: LinkStyle,
    Progress: ProgressStyle,
    Heading: HeadingStyle,
  }
});